(function () {
  var nav  = document.getElementById('nav');
  var hero = document.querySelector('.hero');
  if (!nav || !hero) return;

  var io = null;

  /* The old version hardcoded rootMargin:'-72px', which is the DESKTOP bar's
     height. On a phone the nav is a different size — its top padding comes
     from --mark-corner + --mark-gap so it can sit inside the camera's
     framing mark — so the flip was being measured against a number that had
     nothing to do with the bar on screen. */
  function build() {
    if (io) io.disconnect();

    var h = Math.round(nav.getBoundingClientRect().height) || 72;

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        nav.classList.toggle('is-paper', !e.isIntersecting);
      });
    }, { rootMargin: '-' + h + 'px 0px 0px 0px', threshold: 0 });

    io.observe(hero);
  }

  build();

  /* The bar's height changes at the breakpoint — links become a Menu button
     under 760px — so the observer must be rebuilt, not left with a stale
     margin. */
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(build, 150);
  });

  /* Mobile browsers resize the viewport as the URL bar collapses. */
  window.addEventListener('orientationchange', function () {
    setTimeout(build, 300);
  });
})();

/* scroll reveal */
(function(){
  var items = document.querySelectorAll('.reveal');
  function showAll(){ for (var i=0;i<items.length;i++) items[i].classList.add('is-in'); }

  if (!('IntersectionObserver' in window)) { showAll(); return; }

  try {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold:0.01, rootMargin:'0px 0px -5% 0px' });

    for (var i=0;i<items.length;i++) io.observe(items[i]);
  } catch (err) { showAll(); return; }

  /* failsafe: nothing on this page may stay hidden because of a script */
  setTimeout(showAll, 2500);
})();
/* ---------- MOBILE MENU PANEL ---------- */
(function () {
  var toggle = document.getElementById('navToggle');
  var panel  = document.getElementById('navPanel');
  if (!toggle || !panel) return;

  var LABEL_OPEN  = 'Menu';
  var LABEL_CLOSE = 'Close';

  function open() {
    /* `hidden` comes off FIRST, then .is-open on the next frame. A property
       cannot transition from display:none, so setting both together would
       make the panel appear instantly with no fade. */
    panel.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    document.body.classList.add('is-menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.textContent = LABEL_CLOSE;
  }

  function close() {
    panel.classList.remove('is-open');
    document.body.classList.remove('is-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = LABEL_OPEN;
    /* wait for the fade before hiding, or it vanishes mid-transition */
    setTimeout(function () {
      if (!panel.classList.contains('is-open')) panel.hidden = true;
    }, 220);
  }

  function isOpen() { return toggle.getAttribute('aria-expanded') === 'true'; }

  toggle.addEventListener('click', function () { isOpen() ? close() : open(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  panel.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') close();
  });

  /* Rotating to landscape can cross the 760px breakpoint, where the panel is display:none — it would stay "open" with the body still scroll-locked. */
  window.addEventListener('resize', function () {
    if (isOpen() && window.innerWidth > 760) close();
  });
})();

/* ============================================================
   PRODUCT PAGE
   Every variant's image, price and note is already in the page —
   this only toggles [hidden] and the form's value. Nothing is built
   here, so the page works with JS off and the source stays readable.
   ============================================================ */

(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var input  = root.querySelector('[data-variant-input]');
  var button = root.querySelector('[data-add]');
  var label  = root.querySelector('[data-add-label]');

  function show(group, id) {
    root.querySelectorAll('[' + group + ']').forEach(function (el) {
      el.hidden = el.getAttribute(group) !== id;
    });
  }

  function select(id, push) {
    var swatch = root.querySelector('.picker__swatch[data-variant="' + id + '"]');
    if (!swatch) return;

    root.querySelectorAll('.picker__swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b === swatch ? 'true' : 'false');
    });

    show('data-set', id);
    show('data-price', id);
    show('data-note', id);
    show('data-waitlist', id);
    show('data-stickyset', id);
    show('data-label', id);
    show('data-dots', id);

    if (input) input.value = id;

    var available = swatch.getAttribute('data-available') === 'true';
    if (button) button.disabled = !available;
    if (label) label.textContent = available ? 'Add to Bag' : 'Sold Out';

    /* Keeps the URL shareable — a link to a colour opens on that colour.
       replaceState, not pushState: colour is not a navigation step, and
       back should leave the product, not step through its variants. */
    if (push && window.history && history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('variant', id);
      history.replaceState({}, '', url);
    }
  }

  root.querySelectorAll('.picker__swatch').forEach(function (b) {
    b.addEventListener('click', function () {
      select(b.getAttribute('data-variant'), true);
    });
  });

  /* ---------- the mobile buy bar ---------- */

  /* Shown while the real button is off screen, hidden once it arrives —
     so the two are never both visible and the page never has two live
     Add to Bag buttons competing. Same observer pattern the nav uses.

     It starts hidden and is only revealed if the button is genuinely out
     of view, so a short page that shows the button immediately never
     flashes a bar on load. */
  var bar = root.querySelector('[data-stickybuy]');
  var anchor = root.querySelector('.buy__btn');

  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -12px 0px' }).observe(anchor);
  }

  /* ---------- the folds ---------- */

  root.querySelectorAll('.fold__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var open = head.getAttribute('aria-expanded') === 'true';
      var body = document.getElementById(head.getAttribute('aria-controls'));
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (body) body.hidden = open;
    });
  });
  /* ---------- the mobile dots ----------
     A scroll listener rather than an observer: the row snaps, so the
     nearest slide to the left edge is always the current one, and that
     is a division rather than a threshold. */
  root.querySelectorAll('.object__set').forEach(function (set) {
    var dots = root.querySelector('[data-dots="' + set.dataset.set + '"]');
    if (!dots) return;
    var marks = dots.querySelectorAll('i');

    set.addEventListener('scroll', function () {
      var frames = set.querySelectorAll('.object__frame');
      if (!frames.length) return;
      /* Clamped: at the last slide the row cannot scroll a full width
         further — it stops at scrollWidth minus clientWidth — so the
         division lands short and the final dot never gets marked. */
      var i = Math.round(set.scrollLeft / frames[0].offsetWidth);
      if (i > marks.length - 1) i = marks.length - 1;
      if (i < 0) i = 0;
      if (set.scrollLeft + set.clientWidth >= set.scrollWidth - 2) i = marks.length - 1;
      marks.forEach(function (m, j) { m.classList.toggle('is-on', j === i); });
    }, { passive: true });
  });
})();